module.exports = __webpack_public_path__ + "static/media/close.8c2163b3.svg";